import { renderSeoHead, type SeoLocale } from './config'

export function updateDocumentMetadata(path: string, locale: SeoLocale): void {
  document.documentElement.lang = locale
  document.head.querySelectorAll('[data-seo]').forEach((element) => element.remove())
  document.head.insertAdjacentHTML('beforeend', renderSeoHead(path, locale))
}
